import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";

const Container = styled.div<{ size?: string }>(({ size }) => ({
  borderRadius: "50%",
  width: size ? size : "5rem",
  height: size ? size : "5rem",
  overflow: "hidden",
}));

type Props = {
  size?: string;
  src?: string;
};
const UserImage = ({ size, src }: Props) => {
  const theme = useTheme();
  return (
    <Container size={size}>
      <Image
        src={src ? src : theme.image.default_user.default}
        width="100%"
        height={"100%"}
      />
    </Container>
  );
};

export default UserImage;
